// The page title, and the two very different jobs it does.
//
// In a BROWSER TAB it tells several open tabs on the shop computer apart, so
// it names the screen you are on and then the application.
//
// In the INSTALLED WINDOWS APP it is not a label at all - it is the name.
// Windows builds the window caption, the taskbar entry and the hover tooltip
// as "<app name> - <document title>", so a per-screen title made the shop's
// hover read "Yaghi Butcher POS - <screen>": the application announcing itself
// and then talking about itself. There is one window, so there is nothing to
// tell apart, and the name alone is what a person there needs to see.
//
// The application stays Arabic-first throughout; this only decides what the
// Windows shell repeats back outside it.

import { useEffect } from 'react';

const APP_NAME = 'Yaghi Butcher POS';

/// True when the page is running as the installed app rather than in a tab.
function isInstalledApp(): boolean {
  if (typeof window === 'undefined') return false;
  const standalone = (window.navigator as Navigator & { standalone?: boolean }).standalone;
  if (standalone === true) return true;
  if (typeof window.matchMedia !== 'function') return false;
  return ['standalone', 'window-controls-overlay', 'fullscreen', 'minimal-ui'].some(
    (mode) => window.matchMedia(`(display-mode: ${mode})`).matches,
  );
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = isInstalledApp() ? APP_NAME : `${title} · ${APP_NAME}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
